jQuery(document).ready(function ($) {
    var containerSelector = '.social-share-desktop';
    var socialShareContainerSelector = '.social-share-icons';
    var socialShareButtonSelector = '.st-custom-button';

    var expandedClass = 'is-flex-important';

    var socialExpanded = false;

    // If focus is placed on any element inside of a social container, then
    //  make sure the social container stays expanded
    $(containerSelector + ' *').on('focus', function () {
        // With this element's container as reference, set the social div to expanded
        $(this)
            .closest(containerSelector)
            .find(socialShareContainerSelector)
            .addClass(expandedClass)
        socialExpanded = true;
    });

    // If any element is focused on, collapse social containers generally, but leave
    // the current one alone if the element taking focus is in one of those containers
    $(document).on('focus', '*', function (e) {
        if (!socialExpanded) return;
        // Whatever this element is, unexpand the social div for all other social containers
        //var socialShareContainer = $(this).closest(containerSelector);
        var socialShareContainer = $(this).closest(containerSelector);
        $(containerSelector)
            .not(socialShareContainer)
            .find(socialShareContainerSelector)
            .removeClass(expandedClass);
        if (socialShareContainer.length == 0) {
            socialExpanded = false;
        }
    });

    $(socialShareButtonSelector).on('keyup', function (e) {
        if (e.key == 'Enter') {
            $(this).trigger('click');
        }
    });
});
